import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import { useField } from 'react-final-form';
import { Checkbox, TextField } from '../../../components/form';
import { naturalNumber, required, validators } from '../../../utils/validate';

export const defaultLlmSettings = {
    llmEnabled: false,
    dbMonthlyTokenLimit: 0,
    userMonthlyTokenLimit: 0,
};

const toLimit = (value) => {
    const limit = parseInt(value, 10);
    return isNaN(limit) ? 0 : limit;
};

export const toLlmSettingsPayload = (settings = {}) => ({
    llmEnabled: !!settings.llmEnabled,
    dbMonthlyTokenLimit: toLimit(settings.dbMonthlyTokenLimit),
    userMonthlyTokenLimit: toLimit(settings.userMonthlyTokenLimit),
});

export const isLlmSettingsChanged = (initial, current) => {
    const a = toLlmSettingsPayload(initial);
    const b = toLlmSettingsPayload(current);
    return (
        a.llmEnabled !== b.llmEnabled ||
        a.dbMonthlyTokenLimit !== b.dbMonthlyTokenLimit ||
        a.userMonthlyTokenLimit !== b.userMonthlyTokenLimit
    );
};

const limitValidation = validators(required, naturalNumber);
const enabledSubscription = { subscription: { value: true } };

function ClientDbLlmSettingsForm({ fieldName, readOnly }) {
    const {
        input: { value: enabled },
    } = useField(`${fieldName}.llmEnabled`, enabledSubscription);

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Checkbox
                    name={`${fieldName}.llmEnabled`}
                    label="LLM funkcijos (MGAMA)"
                    readOnly={readOnly}
                />
            </Grid>
            {enabled && (
                <React.Fragment>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            id={`${fieldName}-dbMonthlyTokenLimit`}
                            name={`${fieldName}.dbMonthlyTokenLimit`}
                            label="DB mėnesio tokenų limitas"
                            type="number"
                            helperText="0 = neribota"
                            validate={limitValidation}
                            readOnly={readOnly}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            id={`${fieldName}-userMonthlyTokenLimit`}
                            name={`${fieldName}.userMonthlyTokenLimit`}
                            label="Vartotojo mėnesio tokenų limitas"
                            type="number"
                            helperText="0 = neribota"
                            validate={limitValidation}
                            readOnly={readOnly}
                        />
                    </Grid>
                </React.Fragment>
            )}
        </Grid>
    );
}

ClientDbLlmSettingsForm.defaultProps = {
    fieldName: 'llm',
    readOnly: false,
};

ClientDbLlmSettingsForm.propTypes = {
    fieldName: PropTypes.string,
    readOnly: PropTypes.bool,
};

export default React.memo(ClientDbLlmSettingsForm);
